module.exports = __webpack_public_path__ + "static/media/secondary-shape.e5928859.svg";